import { useState, useEffect } from 'react';
import { useNavigate } from "react-router-dom";
import chatbotImage from '../assets/img/chatbot_icon.png';
import ChatbotLogo from "../assets/img/ChatbotLogo";
import { openWhatsAppChat } from '../util/whatsappUtils';
import "../assets/css/ChatPopup.css";

const ChatPopup = () => {
    const [isChatOpen, setIsChatOpen] = useState(false); // Start closed, will open after delay
    const [messages, setMessages] = useState([]);
    const navigate = useNavigate();

    const toggleChatPopup = () => {
        setIsChatOpen(prevState => !prevState);
    };

    const handleButtonClick = (buttonText) => {
        const routes = {
            "Residential Properties": '/residential-plots-for-sale-in-amaravati',
            "Commercial Spaces": '/commercial-plots-for-sale-in-amaravati',
            "Agricultural Lands": '/agriculture-lands-for-sale-in-amaravati',
        };

        if (routes[buttonText]) {
            navigate(routes[buttonText]);
            setIsChatOpen(false); // Close chat after navigation
        }
    };

    const handleWhatsAppChat = () => {
        openWhatsAppChat('Hi, I would like to know more about your properties and services. Please assist me.');
        setIsChatOpen(false); // Close chat after opening WhatsApp
    };

    useEffect(() => {
        // Show chat popup after 3 seconds on initial load
        const timer = setTimeout(() => {
            setIsChatOpen(true);
            const initialMessages = [
                { text: "Hi, Welcome to Royale Spaces!", sender: "bot" },
                { text: "Your trusted partner in Amaravati real estate! Explore our property types or get assistance with our services.", sender: "bot" },
                { text: "What are you looking for today?", sender: "bot" }
            ];
            setMessages(initialMessages);
        }, 3000);

        return () => clearTimeout(timer);
    }, []);

    const buttonOptions = [
        { text: "Residential Properties", icon: "🏠" },
        { text: "Commercial Spaces", icon: "🏢" },
        { text: "Agricultural Lands", icon: "🌾" },
        { text: "WhatsApp Chat", icon: "💬", isWhatsApp: true },
    ];

    return (
        <div>
            <div onClick={toggleChatPopup} className="chat-button">
                <img src={chatbotImage} alt="Chat Bot" className="chatbot-image" />
            </div>

            {isChatOpen && (
                <div className="chat-popup">
                    <div className="chat-header">
                        <div className="chat-logo">
                            <ChatbotLogo className="chat-logo-img" />
                            <h6 className="chat-header-title" style={{marginTop:'8px'}}>Royale Spaces Help Desk</h6>
                        </div>
                        <span onClick={toggleChatPopup} className="close-button">×</span>
                    </div>

                    <div className="chat-messages">
                        {messages.map((msg, index) => (
                            <div key={index} className={`message ${msg.sender}`}>
                                <div className="message-content">{msg.text}</div>
                            </div>
                        ))}
                    </div>

                    <div className="chat-buttons">
                        {buttonOptions.map((button, index) => (
                            <button
                                key={index}
                                onClick={() => button.isWhatsApp ? handleWhatsAppChat() : handleButtonClick(button.text)}
                                className="chat-action-button"
                                style={{ borderRadius: '4px' }}
                            >
                                <span className="button-icon">{button.icon}</span>
                                {button.text}
                            </button>
                        ))}
                    </div>
                </div>
            )}
        </div>
    );
};

export default ChatPopup;
